import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";
import { UpdateEquipmentButton } from "../../api/api";
import { set } from "react-hook-form";

const SetDataFormat = ({ buttonShouldBeChange }) => {
  const {
    setSetDataFormat,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
  } = useContext(Context);

  const [divided, setDivided] = useState(null);
  const [signed, setSigned] = useState(0);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
  setSetDataFormat(modalName);

  if (buttonShouldBeChange?.data5 != null) {
    const value = buttonShouldBeChange.data5;

    setDivided(value & 0x7f);
    setSigned((value & 0x80) !== 0);
  } else {
    setDivided(1);
    setSigned(false);
  }
}, [buttonShouldBeChange]);

  const handleNumericValue = (value, min, max, setValue) => {
    const numericValue = Number(value);

    if (!Number.isInteger(numericValue)) {
      return setValue("");
    }
    if (numericValue <= min) {
      return setValue(min);
    } else if (numericValue >= max) {
      return setValue(max);
    }

    setValue(numericValue);
  };

  const handleSubmit = () => {
    if(divided > 0 && divided <= 100){
      let data5 = parseInt(
        ((divided & 0b01111111) | (signed ? 0b10000000 : 0))
          .toString(2)
          .padStart(8, "0"),
        2
      );
      setIsLoading(true);
      UpdateEquipmentButton({
        equipment_button_id: buttonShouldBeChange.id,
        name: buttonShouldBeChange.name,
        digit: buttonShouldBeChange.digit,
        icon: buttonShouldBeChange.icon,
        data: [
          buttonShouldBeChange.data1,
          buttonShouldBeChange.data2,
          buttonShouldBeChange.data3,
          buttonShouldBeChange.data4,
          data5,
        ],
        is_continual: buttonShouldBeChange.is_continual,
      }).then(({ data }) => {
        const index = equipmentButtons.findIndex((item) => item.id === buttonShouldBeChange.id);
  
        if (index !== -1) {
          const updatedButtons = [...equipmentButtons];
          updatedButtons[index] = {
            ...updatedButtons[index],
            data5,
          };
  
          setEquipmentButtons(updatedButtons);
        }
        SuccessToast("با موفقیت ثبت شد");
        closeButton.current.click();
        setIsLoading(false);
      });
    } else {
      return ErrorToast('مقدار باید بین 1 تا 100 باشد')
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              تنظیم فرمت داده
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="divided" className="form-label">
                تقسیم بر
              </label>
              <input
                type="text"
                className="form-control"
                id="divided"
                value={divided}
                placeholder="عدد مورد نظر را وارد کنید"
                onChange={(e) =>
                  handleNumericValue(e.target.value, 0, 100, setDivided)
                }
                aria-describedby="defaultFormControlHelp"
              />
              <div id="defaultFormControlHelp" className="form-text">
                داده های شما به این مقدار تقسیم میشوند
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={signed}
                  onChange={() => setSigned((prev) => !prev)}
                  id="signed"
                />
                <label className="form-check-label" htmlFor="signed">
                  علامت‌دار
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button> */}
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetDataFormat;
